import styles from "./empty-player-dashboard.module.css";
import ranaReachingStars from "illustrations/rana/rana-reaching-star.webp";
import ranaCaptain from "illustrations/rana/rana-captain.webp";
import ranaPlayer from "illustrations/rana/rana-player.webp";
import { useTranslation } from "react-i18next";
import MandatoryStep from "components/empty-state/steps/mandatory-step";
import { useNavigate } from "react-router";
import MatchmakingLoading from "components/empty-state/steps/matchmaking-loading";
import { permissionsService } from "services/permissions.service";

const EmptyPlayerDashboard = ({ profile, team_id, preferences }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const canUpdatePreferences = permissionsService.hasPermission(
    "manage_preferences",
    team_id
  );

  const isProfilePending = profile === "pending";

  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        {preferences ? (
          <MatchmakingLoading
            preferences={preferences}
            onClick={() => {
              navigate(`/teams/${team_id}/preferences`);
            }}
            canUpdatePreferences={canUpdatePreferences}
          />
        ) : (
          <MandatoryStep
            data={{
              step: "1",
              title: t("dashboard.empty-state.preferences.pending.title"),
              subtitle: t("dashboard.empty-state.preferences.pending.subtitle"),
              illustration: ranaReachingStars,
              button: t("dashboard.empty-state.preferences.pending.linkText"),
              type: "primary",
              onClick: () => {
                navigate(`/teams/${team_id}/preferences`);
              },
              canPerformAction: canUpdatePreferences,
            }}
            data-testid="data-test-preferences"
          />
        )}
        <MandatoryStep
          data={{
            step: "2",
            title: t("dashboard.empty-state.teams.title"),
            subtitle: t("dashboard.empty-state.teams.description"),
            illustration: ranaCaptain,
            button: t("dashboard.empty-state.teams.linkText"),
            type: preferences ? "primary" : "secondary",
            onClick: () => {
              navigate(`/teams/${team_id}/invite`);
            },
            canPerformAction: true,
          }}
          data-testid="data-test-invite"
        />
        <MandatoryStep
          data={{
            step: "3",
            title: isProfilePending
              ? t("dashboard.empty-state.profile.pending.title")
              : t("dashboard.empty-state.profile.success.title"),
            subtitle: isProfilePending
              ? t("dashboard.empty-state.profile.pending.subtitle")
              : t("dashboard.empty-state.profile.success.subtitle"),
            illustration: ranaPlayer,
            button: isProfilePending
              ? t("dashboard.empty-state.profile.pending.linkText")
              : t("dashboard.empty-state.profile.success.linkText"),
            type: "secondary",
            onClick: () => {
              navigate("/parameters");
            },
            canPerformAction: true,
          }}
          data-testid="data-test-profile"
        />
      </div>
    </section>
  );
};

export default EmptyPlayerDashboard;
